import autoComplete from "@tarekraafat/autocomplete.js";
import { Subject, takeWhile } from "rxjs";
import { WRInitiative, WRInitiativeStatus } from "../app/Models/initiative";
import { WRBericht, WRBerichtStatus } from "../app/Models/bericht";
import { WRAntrag, WRAntragStatus } from "../app/Models/antrag";

declare global {
    interface Window {
        handleInitiative: any;
    }
}

interface SelectPostConfig {
    fetch_url: string;
    post_id: number;
    selector: string;
    ac_selector: string;
    eventName: string;
    multiple?: boolean;
}

// components/ExampleComponent.js
/**
 * Initialize our component here!
 */
export const inithandleInitiative = () => {
    startInitiative();
};

/**
 * Checks if page has autocomplete component
 * @return {Boolean}
 */

const startInitiative = () => {

    window.handleInitiative = () => {

        return {
            initiative: new WRInitiative(new Array<WRBericht>(), new Array<WRAntrag>()),
            ENUM_INITIATIVE_STATUS: WRInitiativeStatus,
            ENUM_BERICHT_STATUS: WRBerichtStatus,
            ENUM_ANTRAG_STATUS: WRAntragStatus,
            ob: null,
            isInit: false,
            json: "",
            tab: "antraege",
            init() {
                if(!this.isInit) {
                    this.isInit = true;
                    this.ob = new Subject();
                    let instance1 = this;
                    this.ob.subscribe(() => {
                        instance1.json = JSON.stringify(instance1.initiative);
                    });
                    let el = document.querySelector("#jsonPrev");
                    if(el!=null) {
                        let content = el.textContent;
                        if (content) {
                            this.initiative = new WRInitiative(new Array<WRBericht>(), new Array<WRAntrag>());
                            this.initiative = JSON.parse(content);
                        }
                    }
                    this.ob.next();
                }                
            },
            addBericht() {
                if(!this.initiative.berichte) this.initiative.berichte = new Array<WRBericht>();
                this.initiative.berichte.push(new WRBericht("", true));
                this.ob.next();
            },
            removeBericht(bericht:WRBericht) {
                this.initiative.berichte.splice(this.initiative.berichte.indexOf(bericht), 1);
                this.ob.next();
            },
            moveUpBericht(bericht:WRBericht) {
                const fromIndex = this.initiative.berichte.indexOf(bericht);
                const toIndex = fromIndex - 1;
                const element = this.initiative.berichte.splice(fromIndex, 1)[0];
                this.initiative.berichte.splice(toIndex, 0, element);
                this.ob.next();
            },
            moveDownBericht(bericht:WRBericht) {
                const fromIndex = this.initiative.berichte.indexOf(bericht);
                const toIndex = fromIndex + 1;
                const element = this.initiative.berichte.splice(fromIndex, 1)[0];
                this.initiative.berichte.splice(toIndex, 0, element);
                this.ob.next();
            },
            backendExpandBericht(bericht:WRBericht) {
                bericht.backend_expanded = !bericht.backend_expanded;
                this.ob.next();
            },
            addAntrag() {
                if(!this.initiative.antraege) this.initiative.antraege = new Array<WRAntrag>();
                this.initiative.antraege.push(new WRAntrag("", "", true));
                this.ob.next();
            },
            removeAntrag(antrag:WRAntrag) {
                this.initiative.antraege.splice(this.initiative.antraege.indexOf(antrag), 1);
                this.ob.next();
            },
            moveUpAntrag(antrag:WRAntrag) {
                const fromIndex = this.initiative.antraege.indexOf(antrag);
                const toIndex = fromIndex - 1;
                const element = this.initiative.antraege.splice(fromIndex, 1)[0];
                this.initiative.antraege.splice(toIndex, 0, element);
                this.ob.next();
            },
            moveDownAntrag(antrag:WRAntrag) {
                const fromIndex = this.initiative.antraege.indexOf(antrag);
                const toIndex = fromIndex + 1;
                const element = this.initiative.antraege.splice(fromIndex, 1)[0];
                this.initiative.antraege.splice(toIndex, 0, element);
                this.ob.next();
            },
            backendExpandAntrag(antrag:WRAntrag) {
                antrag.backend_expanded = !antrag.backend_expanded;
                this.ob.next();
            },
        };
    };
};
